import {ValidatorFn, AbstractControl } from '@angular/forms';


export const CustomOperators = (options: any): ValidatorFn => {
  const operators = {
    '===': (a, b) => { return a === b },
    '!==': (a, b) => { return a !== b },
    '>=': (a, b) => { return parseInt(a) >= parseInt(b) },
    '<=': (a, b) => { return parseInt(a) <= parseInt(b) },
    '>': (a, b) => { return parseInt(a) > parseInt(b) },
    '<': (a, b) => { return parseInt(a) < parseInt(b) }
  };
  const optionsSplit = options.split(',');

  const error = {
    invalidOperators: true,
    message: 'This values missmatch rule'
  }


  return (control: AbstractControl): any => {

    try {
      if (!control.value) {
        return null;
      }
  
      if (optionsSplit.length > 1) {
        return operators[optionsSplit[0]](control.value, optionsSplit[1]) ? null : error;
      }
    } catch(error) {
    }

  };
};



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/custom-validators/components/operators/operators.validator.ts